import React from 'react';
import clsx from 'clsx';
import { CardProps } from '@mui/material/Card';

import { useAppProvider } from 'providers/app/app';

import { M3CardBase } from './M3Card.styles';

type M3CardProps = CardProps & {
  focused?: boolean;
  noHover?: boolean;
};

const M3Card: React.FC<M3CardProps> = ({
  className,
  focused,
  noHover,
  ...restProps
}) => {
  const { isDarkMode } = useAppProvider();
  return (
    <M3CardBase
      {...restProps}
      className={clsx(className, 'm3-card', {
        focused,
        'no-hover': noHover,
        'dark-mode-card': isDarkMode,
      })}
    />
  );
};

export default M3Card;
